import type { Rng } from './rng';

// Todos os nomes são gerados por combinação de sílabas inventadas: nenhum clube ou jogador real.

const PRENOMES = [
  'Adriel', 'Bruno', 'Caio', 'Davi', 'Elias', 'Fabrício', 'Gael', 'Heitor', 'Igor', 'Joaquim',
  'Kauê', 'Leandro', 'Murilo', 'Nicolas', 'Otávio', 'Paulo', 'Rafael', 'Samuel', 'Thiago', 'Vitor',
  'Wesley', 'Yuri', 'Ângelo', 'Breno', 'Cauã', 'Diego', 'Emanuel', 'Felipe', 'Gustavo', 'Hugo',
  'Italo', 'Jonas', 'Kleber', 'Lucas', 'Matheus', 'Nilton', 'Osvaldo', 'Pedro', 'Renan', 'Sandro',
];

const SILABAS_INICIO = ['Ra', 'Mi', 'Lu', 'Ca', 'Be', 'To', 'Fe', 'Ni', 'Jo', 'Ar', 'Sa', 'Va', 'Pe', 'Gi', 'Mo', 'De', 'Lo', 'Ma'];
const SILABAS_MEIO = ['ni', 'ta', 'ro', 'sa', 'le', 'ma', 'co', 'di', 've', 'lo', 'ba', 'ne', 'ri', 'to'];
const SILABAS_FIM = ['dro', 'ra', 'nho', 'to', 'cio', 'ldo', 'res', 'les', 'mar', 'tim', 'lho', 'ro', 'na', 'vo'];

const PREFIXOS_CLUBE = ['Atlético', 'Esporte Clube', 'Sport', 'União', 'Real', 'Grêmio', 'Associação', 'Clube Atlético', 'Racing', 'Independente'];
const LUGARES = [
  'Vale do Sol', 'Serra Verde', 'Porto Novo', 'Campo Alto', 'Rio Claro', 'Monte Azul', 'Praia Dourada', 'Pedra Branca',
  'Lagoa Funda', 'Terra Boa', 'Alto Mar', 'Cachoeira Grande', 'Vila Nova', 'Planalto', 'Ilha Verde', 'Morro Alto',
  'Campina', 'Boa Esperança', 'São Tomé', 'Santa Aurora', 'Ribeirão Preto Velho', 'Mata Norte', 'Chapada', 'Cerrado Azul',
];

const CORES: [string, string][] = [
  ['#c62828', '#ffffff'], ['#1565c0', '#ffffff'], ['#2e7d32', '#ffffff'], ['#f9a825', '#212121'], ['#6a1b9a', '#ffffff'],
  ['#00838f', '#ffffff'], ['#ef6c00', '#212121'], ['#212121', '#ffffff'], ['#ad1457', '#ffffff'], ['#455a64', '#ffffff'],
  ['#558b2f', '#ffffff'], ['#283593', '#ffeb3b'], ['#b71c1c', '#212121'], ['#00695c', '#ffffff'], ['#d84315', '#ffffff'],
  ['#4527a0', '#ffffff'], ['#0277bd', '#ffffff'], ['#9e9d24', '#212121'], ['#37474f', '#ffcc80'], ['#c2185b', '#ffffff'],
];

export function nomeJogador(rng: Rng): string {
  const sobrenome = rng.escolher(SILABAS_INICIO) + rng.escolher(SILABAS_MEIO) + rng.escolher(SILABAS_FIM);
  return `${rng.escolher(PRENOMES)} ${sobrenome.charAt(0).toUpperCase()}${sobrenome.slice(1)}`;
}

export function nomesClubes(rng: Rng, quantidade: number): { nome: string; sigla: string; cores: [string, string] }[] {
  const lugares = rng.embaralhar([...LUGARES]);
  const cores = rng.embaralhar([...CORES]);
  const usados = new Set<string>();
  const resultado: { nome: string; sigla: string; cores: [string, string] }[] = [];
  for (let i = 0; i < quantidade; i++) {
    const lugar = lugares[i % lugares.length] as string;
    let sigla = lugar
      .split(' ')
      .map((p) => p.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 3);
    if (sigla.length < 3) sigla = (sigla + lugar.replace(/ /g, '')).toUpperCase().slice(0, 3);
    while (usados.has(sigla)) sigla = sigla.slice(0, 2) + String.fromCharCode(65 + rng.inteiro(26));
    usados.add(sigla);
    resultado.push({
      nome: `${rng.escolher(PREFIXOS_CLUBE)} ${lugar}`,
      sigla,
      cores: cores[i % cores.length] as [string, string],
    });
  }
  return resultado;
}
